import Box from "@mui/material/Box";
import styled from "styled-components";
import { deviceSpec } from "breakpoints";
import { Paper } from "@mui/material";

export const ApplicationRootStyle = styled(Box)`
  display: grid;    
  height: 100vh;
  width: 100vw;
  grid-template-rows: 1fr 51px;
  overflow: hidden;

  .Toastify {
    .Toastify__toast-container {
      width: 100%;
      position: relative;
      z-index: 100;
      padding: 0;
      top: 0;

      .Toastify__toast {
        margin: 0;
        min-height: min-content;
        position: absolute;
        width: 100%;
        top: calc((var(--nth) - 1) * 12px);
      }
    }

    .Toastify__close-button {
      align-self: center;
    }
  }

  .rs-picker-input-group, .rs-picker-input-group input {
    border: 1px solid ${({theme}) => theme.colors.actionButtonColor};
    height: 30px;
    background-color: transparent;
    color: ${({theme}) => theme.colors.textColor};
  }

  .rs-calendar-table-cell-content {
    span {
      color: ${({theme}) => theme.colors.textColor}; 
    }
  }
  
  .Toastify__toast-icon {
    svg {
      color: white;
    }
  }
`;

export const Wrapper1 = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const Main1 = styled.div`
  width: 100%;
  height: 150vh;
`;

export const Sidebar1 = styled.div`
  position: sticky;
  top: 0;
  height: 125vh;
`;

export const ComponentsAndHeaderRootStyles = styled.main`
  height: 100%;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
`;

export const Main = styled.main`
  display: grid;
  // sidebar should have preferential space, the rest goes to the component area
  grid-template-columns: auto 1fr;
  overflow: hidden;
`;

export const Body = styled.body`
  overflow: hidden;
`;

// For the tooltip, which is currently unused
export const TooltipContainer = styled.div<{ visible: string, top: number, right: number }>`
  position: absolute;
  z-index: 2;
  display: ${(props) => (props.visible === "true" ? "inherit" : "none")};
  top: ${(props) => props.top}px;
  left: ${(props) => props.right}px;

  @media ${deviceSpec.isTablet} {
    display: none;
  }
`;

export const TooltipContentSpan = styled('span')`
    display: flex;
    align-items: flex-start;
    z-index: 10001;
    margin-left: 10px;

    .pointer-left {
      height: 0.75rem;
      width: 0.75rem;
      transform: rotate(45deg);
      border-radius: 0 0 0 4px;
      position: relative;
      top: 15%;
      background-color: ${({theme}) => theme.colors.dark};
      left: 0.375rem;
    }
`;
